<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="rest-password-dialog" label-position="top" size="large">
    <el-form-item label="邮箱" prop="email">
      <el-input class="ruleForm-email" v-model="modelMail" placeholder="请输入工作邮箱" :disabled="Boolean(defaultMobile)">
        <template slot="suffix">@ehang.com</template>
      </el-input>
    </el-form-item>
    <el-form-item label="验证码" prop="code">
      <div class="code-btn">
        <el-input v-model="ruleForm.code" maxlength="6" placeholder="验证码">
          <template #suffix>
            <span class="letterHover code-text" :class="{'disabled': codeText > 0}" @click="sendCode" :loading="loading">{{codeTextShow}}</span>
          </template>
        </el-input>
        <!-- <wf-button class="code" plain @click.native="sendCode" :loading="loading" :disabled="codeText > 0" size="large">{{codeText || '发送'}}</wf-button> -->
      </div>
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="repassword">
      <el-input type="password" v-model="ruleForm.repassword" placeholder="请输入密码"></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import { isEmail } from '@/utils/validate'
import qs from 'qs';
import md5 from 'js-md5';
import api from '@/services/api/login/login'
export default {
  props: ['defaultMobile'],
  data() {
    const isEmailReg = (rule, value, callback) => {
      if (!isEmail(value)) {
        return callback(new Error('请输入正确的邮箱'));
      }
      callback();
    };
    const againPass = (rule, value, callback) => {
      if (!/[A-Z]/.test(value)) {
        return callback(new Error('密码必须包含至少一个大写字母'));
      }
      if (!/[a-z]/.test(value)) {
        return callback(new Error('密码必须包含至少一个小写字母'));
      }
      if (!/[A-Z]/.test(value)) {
        return callback(new Error('密码必须包含至少一个数字'));
      }
      if (!/[~!@#$%^&*()\-_=+{};:<,.>?]/.test(value)) {
        return callback(new Error('密码必须包含至少一个特殊符号, 包含 ~!@#$%^&*()\-_=+{};:<,.>?'));
      }
      if (!/[A-Z]/.test(value)) {
        return callback(new Error('密码必须包含至少一个大写字母'));
      }
      if (!/[A-Z]/.test(value)) {
        return callback(new Error('密码必须包含至少一个大写字母'));
      }
      if (value.length < 8) {
        return callback(new Error('密码必须包含至少含有8个字符'));
      }
      if (this.ruleForm.password && this.ruleForm.repassword && this.ruleForm.password !== this.ruleForm.repassword) {
        return callback(new Error('两次新密码不一致，请重新输入！'));
      }
      callback();
    };
    return {
      ruleForm: {
        email: '',
        code: '',
        password: '',
        repassword: ''
      },
      modelMail: '',
      loading: false,
      loadingPass: false,
      suffix: '@ehang.com',
      rules: {
        email: [{ required: true, message: '工作邮箱不能为空', trigger: 'change' }, { validator: isEmailReg, trigger: 'change' }],
        code: [{ required: true, message: '验证码不能为空', trigger: 'change' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'change' }, { validator: againPass, trigger: 'change' }],
        repassword: [{ required: true, message: '密码不能为空', trigger: 'change' }, { validator: againPass, trigger: 'change' }]
      },
      codeText: 0,
      timer: '',
      havSend: false
    }
  },
  watch: {
    modelMail: {
      handler() {
        if (this.modelMail) {
          this.ruleForm.email = this.modelMail + this.suffix
        } else {
          this.ruleForm.email = ''
        }
      },
      immediate: true
    },
    defaultMobile: {
      handler() {
        this.modelMail = this.defaultMobile
        this.ruleForm.email = this.defaultMobile + this.suffix
      },
      immediate: true
    }
  },
  computed: {
    codeTextShow() {
      if(this.codeText > 0) {
        return this.codeText + 's'
      } else if(this.havSend) {
        return '重新获取'
      } else {
        return '获取验证码'
      }
    }
  },
  methods: {
    sendCode() {
      this.$refs.ruleForm.validateField('email', val => {
        if (!val) {
          if (this.codeText > 0) return
          this.loading = true
          let parmas = {
            type: 'email',
            email: this.ruleForm.email,
            timestamp: Math.floor(new Date().getTime() / 1000)
          }
          parmas.sign = this.getSign(parmas)
          api.getVerificationCode(parmas).then(res => {
            this.loading = false
            this.havSend = true
            this.setTime()
          }).catch(err => {
            this.loading = false
          })
        }
      })
    },
    setTime() {
      this.codeText = 60
      this.timer = setInterval(() => {
        this.codeText = this.codeText - 1
        if (this.codeText === 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    getSign(obj) {
      let result = {}
      Object.keys(obj).sort().reverse().forEach(res => {
        result[res] = obj[res]
      })
      console.log('签名序列化', decodeURIComponent(qs.stringify(result, { strictNullHandling: true })) + '&eh_work_flow')
      return md5(md5(decodeURIComponent(qs.stringify(result, { strictNullHandling: true })) + '&eh_work_flow'))
    },
    resetPassword() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loadingPass = true
          let parmas = {
            type: 'email',
            timestamp: Math.floor(new Date().getTime() / 1000),
            ...this.ruleForm
          }
          parmas.sign = this.getSign(parmas)
          api.resetPassword(parmas).then(res => {
            this.loadingPass = false
            this.$message({
              message: '密码重置成功！',
              type: 'success'
            });
            this.resetFields()
            this.$emit('restSuccess')
          }).catch(err => {
            this.loadingPass = false
          })
        }
      });
    },
    resetFields() {
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>
<style lang="scss">
.rest-password-dialog {
  .el-form-item__label {
    line-height: 1.3;
    padding-bottom: 8px;
  }
  .el-form-item:last-child {
    margin: 0;
  }
  .code-btn {
    display: flex;
    align-items: center;
  }
  .code-text {
    padding-right: 16px;
    font-size: 14px;
    font-weight: 400;
    &.disabled {
      color: rgba(39, 39, 39, 0.6);
      cursor: auto !important;
    }
  }
  .code {
    margin-left: 16px;
    width: 100px;
  }
  .ruleForm-email {
    .el-input__inner {
      padding-right: 126px;
    }
    .el-input__suffix {
      color: initial;
      right: 14px;
    }
    &.is-disabled .el-input__inner {
      color: initial !important;
    }
  }
  .btn-check {
    width: 200px;
  }
  .el-form-item {
    margin-bottom: 26px;
  }
}
</style>
